import { useEffect, useState } from "react";
import api from "../api";
import { Spinner } from "../components/Logo";
import { PageHeader, EmptyState } from "../components/ui";
import { Megaphone } from "lucide-react";

export default function Announcements() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/announcements").then((r) => setData(r.data.announcements)).catch(() => {});
  }, []);

  return (
    <div data-testid="announcements-page">
      <PageHeader overline="Stay updated" title="Announcements" desc="News, new content and platform updates from the InfosecGig team." />
      {!data ? <Spinner /> : data.length === 0 ? (
        <EmptyState icon={Megaphone} title="No announcements" desc="You're all caught up." />
      ) : (
        <div className="space-y-4">
          {data.map((a) => (
            <div key={a.id} className="card p-6" data-testid={`announcement-${a.id}`}>
              <div className="flex items-start gap-4">
                <div className="h-10 w-10 rounded-lg bg-[#F26522]/15 flex items-center justify-center shrink-0"><Megaphone size={18} className="text-[#F26522]" /></div>
                <div>
                  <h3 className="font-heading font-semibold text-lg">{a.title}</h3>
                  <p className="text-slate-400 text-sm mt-2 leading-relaxed">{a.body}</p>
                  <p className="text-xs text-slate-500 mt-3">{new Date(a.publish_at).toLocaleString()}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
